import React from 'react';
import {compose, graphql} from 'react-apollo';

import {Grid, Paper, Typography} from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import {Add, Close, Remove} from '@material-ui/icons';
import classNames from 'classnames';
import Button from 'components/button';
import {reverse} from 'core/urls';
import updateCartMutation from 'graphql/mutations/carts/update-cart.gql';
import cartQuery from 'graphql/queries/cart.gql';
import styles from './styles.css';

@compose(graphql(updateCartMutation, {
    props: ({mutate}) => ({
        onUpdate: variables => mutate({
            variables,
            refetchQueries: [{query: cartQuery}],
        }),
    }),
}))
export default class CartPopup extends React.Component {
    state = {
        loading: false,
    };

    async updateQuantity(item, quantity = 0) {
        if (this.state.loading) return;
        this.setState({loading: true});

        await this.props.onUpdate({
            quantity,
            variation: item.productVariation.id,
            withOrganizationLogo: item.withOrganizationLogo,
        });
        this.setState({loading: false});
    }

    handleClose = () => {
        this.props.setAnchorEl(null);
    };

    render() {
        const {anchorEl, cart} = this.props;
        const open = Boolean(anchorEl);
        const id = open ? 'simple-popover' : undefined;

        return (
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}>
                <Paper elevation={3} className={styles.popver}>
                    <Grid container spacing={2} direction='column' >
                        {
                            cart.items.toSorted((a, b) => a.code.localeCompare(b.code)).map(({thumbnail, total, quantity, totalCurrency, name, code, productVariation, withOrganizationLogo}) =>
                                (<Grid container item key={code} alignItems='center' className={styles.row}>
                                    <Grid item xs={1} >
                                        <Close
                                            onClick={() => this.updateQuantity({
                                                productVariation,
                                                withOrganizationLogo,
                                            }, 0)}
                                            className={classNames(styles.removeButton, this.state.loading && styles.disabledButton)}
                                            fontSize='large'
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <img src={thumbnail} className={styles.img} />
                                    </Grid>
                                    <Grid item xs={3} className={styles.itemDescription}>
                                        <Typography variant='h2' style={{fontWeight: 'bold'}}>{name}</Typography>
                                    </Grid>
                                    <Grid container item xs={2} justify='center' alignItems='center'>
                                        <Grid item>
                                            <Remove
                                                className={classNames(styles.modifyButton, this.state.loading && styles.disabledButton)}
                                                onClick={() => this.updateQuantity({
                                                    productVariation,
                                                    withOrganizationLogo,
                                                }, quantity - 1)}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant='h2'
                                                style={{
                                                    fontWeight: 'bold',
                                                    marginLeft: '5px',
                                                    marginRight: '5px',
                                                }}>{quantity}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Add
                                                className={classNames(styles.modifyButton, this.state.loading && styles.disabledButton)}
                                                onClick={() => this.updateQuantity({
                                                    productVariation,
                                                    withOrganizationLogo,
                                                }, quantity + 1)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} className={styles.rowTotal}>
                                        <Typography variant='h2' style={{fontWeight: 'bold'}}>{totalCurrency} {total}</Typography>
                                    </Grid>
                                </Grid>))
                        }
                        <hr />
                        <Grid item container justify='space-between' className={styles.subtotal}>
                            <Grid item sx={1}><Typography variant='h2' style={{fontWeight: 'bold'}}>Subtotal</Typography></Grid>
                            <Grid item sx={2}><Typography variant='h2' style={{fontWeight: 'bold'}}>{cart.totalCurrency} {cart.total}</Typography></Grid>
                        </Grid>
                        <Grid item className={styles.finishButton}>
                            {(cart.items.length > 0) ?
                                <Button link={reverse('cart')} onClick={this.handleClose} theme='yellow' className={styles.finishButton}>
                                    <Typography variant='h2' style={{fontWeight: 'bold'}}>Finalizar Pedido</Typography>
                                </Button>
                                :
                                <Button link={reverse('merchandising')} onClick={this.handleClose} theme='yellow' className={styles.finishButton}>
                                    <Typography variant='h2' style={{fontWeight: 'bold'}}>Iniciar Pedido</Typography>
                                </Button>
                            }
                        </Grid>
                    </Grid>

                </Paper>
            </Popover >
        );
    }
}



// WEBPACK FOOTER //
// ./components/cart-popup/index.js